import React, { FunctionComponent, useMemo } from 'react'
import { Text, Link } from '@sitecore-jss/sitecore-jss-react'
import { anchorWithId } from '../../helpers/anchorWithId.helper'
import {
  BrandPortfolioProps,
  BrandPortfolioCard,
} from './types/BrandPortfolio.types'
import './BrandPortfolio.scss'

import RoutableSitecoreLink from '../../react-only-components/RoutableSitecoreLink'

const emptyElement: BrandPortfolioCard = {
  id: '',
  fields: {
    Image: { value: {} },
    Link: { value: {} },
  },
}

const BrandPortfolio: FunctionComponent<BrandPortfolioProps> = ({
  fields: { eyebrow, Title, Subtitle, link, Cards, IsTwoColumns },
}) => {
  const CardsWithImprovedLayout = useMemo(
    () =>
      Cards.length === 4 && IsTwoColumns.value
        ? [...Cards.slice(0, 2), emptyElement, ...Cards.slice(2)]
        : Cards,
    [Cards]
  )

  return (
    <div className="BrandPortfolio">
      <div>
        <section>
          <Text tag="p" className="BrandPortfolio__preTitle" field={eyebrow} />
          <Text tag="h3" className="BrandPortfolio__title" field={Title} />
          <Text tag="p" className="BrandPortfolio__body" field={Subtitle} />
          <Link field={link} className="BrandPortfolio__cta" />
        </section>

        <section>
          <div className="BrandPortfolio__cards_container">
            {CardsWithImprovedLayout.map(
              (
                {
                  id,
                  fields: {
                    Image: { value },
                    Link: {
                      value: { href, anchor },
                    },
                  },
                },
                idx
              ) => (
                <>
                {/* && !IsTwoColumns.value */}
                  <div className={!value?.src? "empty_element": ""} key={idx} {...(id ? { id: id } : {})}>
                    {id && (
                      <a
                        href={anchorWithId(href ?? '', anchor)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={value?.src} alt={(value?.alt as string) ?? ''} />
                      </a>
                    )}
                  </div>
                </>
              )
            )}
          </div>
        </section>
      </div>
    </div>
  )
}

export default BrandPortfolio
